import React from 'react';
import {useState} from 'react'
import axios from 'axios'
import { useNavigation } from '@react-navigation/native';
import { View, Text, Image, TextInput, TouchableOpacity } from 'react-native';
import AlligensLogo from '../images/AlligensLogo.png'
import AlligensBackground from '../images/AlligensBackground.jpeg'

//import { Dropdown } from 'react-native-element-dropdown';


const Customer = ({ route }) => {
  
  const navigation = useNavigation();
  const [customer, setCustomer]= useState({
    nombre: '',
    direccion: '',
    correo: '',
    descuento: '',
    telefono: '',});
  

  

    const handleInsert = async () => {
      try {
        const response = await axios.post("https://alligensback.onrender.com/customers", customer);
        console.log('Response:', response.data); // Log the response data from the server
        alert('Customer created successfully!'); // Simple success feedback
        navigation.navigate('Customersv2');
        // Optionally, navigate to another screen or refresh the customer list here
      } catch (err) {
        console.error('Error:', err);
        alert('Failed to create customer. Check console for more details.'); // Simple error feedback
      }
    }



 
  
  return (
    <View style={styles.container}>
      <Image
        source={AlligensBackground}
        style={styles.background}
      />
      <View style={styles.logoContainer}>
        <Image
          source={AlligensLogo}
          style={styles.logo}
        />
      </View>
      <View style={styles.formContainer}>
        <Text style={styles.title}>Customer</Text>
        <View style={styles.card}>
        <View style={styles.inputContainer}>
  <Text style={styles.label}>Name</Text>
  <TextInput
    style={styles.input}
    value={customer.nombre}
    onChangeText={(text) => setCustomer({ ...customer, nombre: text })}
    placeholder="Name"
    placeholderTextColor="#999"
  />
</View>
<View style={styles.inputContainer}>
  <Text style={styles.label}>Address</Text>
  <TextInput
    style={styles.input}
    value={customer.direccion}
    onChangeText={(text) => setCustomer({ ...customer, direccion: text })}
    placeholder="Address"
    placeholderTextColor="#999"
  />
</View>
<View style={styles.inputContainer}>
  <Text style={styles.label}>Email</Text>
  <TextInput
    style={styles.input}
    value={customer.correo}
    onChangeText={(text) => setCustomer({ ...customer, correo: text })}
    placeholder="Email"
    placeholderTextColor="#999"
  />
</View>
<View style={styles.inputContainer}>
  <Text style={styles.label}>Discount</Text>
  <TextInput
    style={styles.input}
    value={customer.descuento}
    onChangeText={(text) => setCustomer({ ...customer, descuento: text })}
    placeholder="Discount"
    placeholderTextColor="#999"
  />
</View>
<View style={styles.inputContainer}>
  <Text style={styles.label}>Phone</Text>
  <TextInput
    style={styles.input}
    value={customer.telefono}
    onChangeText={(text) => setCustomer({ ...customer, telefono: text })}
    placeholder="Phone"
    placeholderTextColor="#999"
  />
</View>
          
          <TouchableOpacity style={styles.button} onPress={() => handleInsert()}>
            <Text style={styles.buttonText}>Create</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

export default Customer;

const styles = {
  container: {
    flex: 1,
  },
  background: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  logoContainer: {
    alignItems: 'center',
    marginTop: 120,
  },
  logo: {
    width: 120,
    height: 120,
    borderRadius:60,
    resizeMode: 'contain',
  },

    formContainer: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      fontSize: 24,
      color: '#fff',
      marginBottom: 20,
      marginTop: 20,
    },
    card: {
      width: '80%',
      backgroundColor: '#000',
      borderRadius: 4,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.2,
      shadowRadius: 2,
      padding: 20,
      marginBottom: 20,
    },
    inputContainer: {
      marginBottom: 20,
    },
    label: {
      fontSize: 16,
      color: '#fff',
    },
    input: {
      height: 40,
      borderRadius:6,
      borderWidth: 1,
      borderColor: '#ddd',
      color: '#fff',
      paddingLeft:10,
    },
    button: {
      width: '100%',
      height: 40,
      backgroundColor: '#808080',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
    },
    buttonText: {
      color: '#fff',
      fontSize: 16,
    },
    dropdown: {
      height: 50,
      borderColor: 'gray',
      borderWidth: 0.5,
      borderRadius: 8,
      paddingHorizontal: 8,
    },
    icon: {
      marginRight: 5,
    },
    placeholderStyle: {
      fontSize: 16,
    },
    selectedTextStyle: {
      fontSize: 16,
    },
    iconStyle: {
      width: 20,
      height: 20,
    },
    inputSearchStyle: {
      height: 40,
      fontSize: 16,
    },

  };
  
                                            